'use client';

import { useTranslation } from 'react-i18next';

import { Button } from '@kit/ui/button';
import { Trans } from '@kit/ui/trans';

import { ScrollableChipRow } from './scrollable-chip-row';

export function StaffAvailabilityFilter({
  staff,
  selectedStaffId,
  onSelectStaff,
  isLoading,
}: {
  staff: { id: string; name: string }[];
  selectedStaffId: string;
  onSelectStaff: (staffId: string) => void;
  isLoading: boolean;
}) {
  const { t } = useTranslation('bookings');
  if (isLoading || staff.length === 0) return null;

  if (staff.length === 1) {
    return (
      <p
        className="text-muted-foreground mb-4 text-sm"
        data-test="single-available-staff"
      >
        <Trans
          i18nKey="bookings:staffFilter.withStaff"
          values={{ name: staff[0]!.name }}
        />
      </p>
    );
  }

  return (
    <fieldset className="mb-4 min-w-0" data-test="staff-availability-filter">
      <legend className="sr-only">
        <Trans i18nKey="bookings:staffFilter.label" />
      </legend>
      <ScrollableChipRow
        backLabel={t('staffFilter.previousStaff')}
        forwardLabel={t('staffFilter.nextStaff')}
        testId="staff-filter"
      >
        {[{ id: '', name: t('staffFilter.anyStaff') }, ...staff].map(
          (person) => (
            <Button
              key={person.id}
              type="button"
              variant={selectedStaffId === person.id ? 'default' : 'outline'}
              aria-pressed={selectedStaffId === person.id}
              data-native-booking-choice
              data-test="staff-filter-option"
              data-staff-id={person.id}
              className="h-11 shrink-0 rounded-full px-3 py-2 text-xs whitespace-nowrap"
              onClick={() => onSelectStaff(person.id)}
            >
              {person.name}
            </Button>
          ),
        )}
      </ScrollableChipRow>
    </fieldset>
  );
}
